import { LeftOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useMatch,
  useNavigate,
} from 'react-router-dom';

import Sidebar from '../../components/TechnicianSidebar/';
import TopNavbar from '../../components/TopNavbar';

import MenuTechnician from '../../pages/Services/Menu';
import TechnicianProfile from '../../pages/Technicians/Profile';
import Orders from '../../pages/Technicians/Orders';
import OrderDetail from '../../pages/Technicians/Orders/Details';
import Invoices from '../../pages/Technicians/Invoices';
import InvoiceDetail from '../../pages/Technicians/Invoices/Details';
import Jobs from '../../pages/Technicians/Jobs';
import JobDetail from '../../pages/Technicians/Jobs/Details';

import styles from './index.module.scss';

interface Props {
  header?: string;
}

const headers = [
  {
    path: '/my-technician/profile',
    header: 'ข้อมูลและรายละเอียดช่าง',
  },
  {
    path: '/my-technician/orders',
    header: 'คำสั่งซื้อบริการ',
  },
  {
    path: '/my-technician/invoices',
    header: 'ใบเสนอราคาค่าประเมินงาน',
  },
  {
    path: '/my-technician/jobs',
    header: 'งานในระบบ',
  },
  {
    path: '/my-technician',
    header: 'โปรไฟล์ช่าง',
  },
];

interface SidebarContextType {
  currentItem: string | null;
  setCurrentItem: (id: string) => void;
  currentPage: string | null;
  setCurrentPage: (id: string) => void;
}

export const SidebarContext = React.createContext<SidebarContextType>({
  currentItem: null,
  setCurrentItem: () => {},
  currentPage: null,
  setCurrentPage: () => {},
});

const backtrackNavs = [
  {
    name: 'index',
    label: 'โปรไฟล์ช่าง',
    path: '/my-technician',
  },
  {
    name: 'orders-detail',
    label: 'คำสั่งซื้อบริการ',
    path: '/my-technician/orders',
  },
  {
    name: 'invoices-detail',
    label: 'ใบเสนอราคาประเมินงาน',
    path: '/my-technician/invoices',
  },
  {
    name: 'jobs-detail',
    label: 'งานในระบบ',
    path: '/my-technician/jobs',
  },
];

const TechnicianLayout: React.FC<Props> = (props) => {
  const location = useLocation();
  const currentPath = useSelector(() => location?.pathname);
  const isMyTechnicalPage = useMatch('/my-technician');
  const isProfilePage = useMatch('/my-technician/profile');
  const navigate = useNavigate();

  const [isDetailPage, setIsDetailPage] = useState<boolean>(false);
  const [currentItem, setCurrentItem] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<string>('');
  const [backtrackNav, setBacktackNav] = useState<string>('');
  const header = useSelector(() => {
    const h = headers.find((h) => currentPath.includes(h.path));
    return h?.header;
  });
  const currentBacktrackNav = useSelector(() => {
    return backtrackNavs.find((n) => n.name === backtrackNav);
  });
  const sidebarStyles = useSelector(() => {
    return isDetailPage
      ? styles.detailSidebarContainer
      : styles.technicianSidebarContainer;
  });
  const contentStyles = useSelector(() => {
    return isDetailPage
      ? styles.detailContentContainer
      : styles.technicianContentContainer;
  });

  useEffect(() => {
    if (currentPage.includes('-detail')) {
      setIsDetailPage(true);
      setBacktackNav(currentPage);
    } else if (
      currentPath === '/my-technician/orders/' ||
      currentPath === '/my-technician/jobs/' ||
      currentPath === '/my-technician/invoices/'
    ) {
      setIsDetailPage(false);
      setCurrentItem('');
      setBacktackNav('index');
    } else if (!isMyTechnicalPage) {
      setIsDetailPage(false);
      setBacktackNav('index');
    }
  }, [currentPage, currentPath]);

  const handleBack = (e: React.MouseEvent) => {
    if (!currentBacktrackNav) return null;

    e.preventDefault();
    // navigate(currentBacktrackNav.path);
    navigate('/my-technician');
    setBacktackNav('');
  };

  const BacktrackNav = () => {
    if (!currentBacktrackNav) return null;

    return (
      <div className={styles.backtrackContainer} onClick={handleBack}>
        <LeftOutlined />
        {/* <span>{currentBacktrackNav.label}</span> */}
        <span>โปรไฟล์ช่าง</span>
      </div>
    );
  };

  return (
    <>
      <TopNavbar logoPath='/' />

      <div className={styles.layoutContainer}>
        <BacktrackNav />
        <div className={styles.header}>{header}</div>
        {isMyTechnicalPage || isProfilePage ? (
          <>
            <Routes>
              <Route path='/' element={<MenuTechnician />} />
              <Route path='/profile' element={<TechnicianProfile />} />
            </Routes>
          </>
        ) : (
          <>
            <SidebarContext.Provider
              value={{
                currentItem,
                setCurrentItem,
                currentPage,
                setCurrentPage,
              }}
            >
              <div className={styles.technicianLayoutContainer}>
                <div className={sidebarStyles}>
                  <Sidebar />
                </div>
                <div className={contentStyles}>
                  <Routes>
                    <Route path='orders' element={<Orders />} />
                    <Route path='orders/:id' element={<OrderDetail />} />
                    <Route path='invoices' element={<Invoices />} />
                    <Route path='invoices/:id' element={<InvoiceDetail />} />
                    <Route path='jobs' element={<Jobs />} />
                    <Route path='jobs/:id' element={<JobDetail />} />
                    <Route
                      path='/*'
                      element={<Navigate to='/my-technician' />}
                    />
                  </Routes>
                </div>
              </div>
            </SidebarContext.Provider>
          </>
        )}
      </div>
    </>
  );
};

export default TechnicianLayout;
